let _sentryLib = null;

export function setup(app, router) {
  import("@sentry/vue").then((Sentry) => {
    _sentryLib = Sentry;

    _sentryLib.init({
      app,
      dsn: "https://43a077fa02c844978a605c1c8441851d@o483474.ingest.sentry.io/4504566243262464",
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracePropagationTargets: [
            "localhost",
            "autobooking-v2.dev.kodland.org",
            "autobooking-v2.kodland.org",
            /^\//,
          ],
        }),
        new Sentry.Replay(),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.3,
      logErrors: true,
    });
  });
}

export function captureMessage(message) {
  if (_sentryLib) {
    _sentryLib.captureMessage(message);
  }
}
